<script>
    import router from "page";
    import { onMount } from "svelte";

    import Login from "./authentication/Login.svelte";

    import Loader from "./components/Loader.svelte";
    import Message from "./components/Message.svelte";
    import Modal from "./components/Modal.svelte";

    import Admin from "./admin/Admin.svelte";
    import Users from "./admin/Users.svelte";
    import Catalogue from "./admin/Catalogue.svelte";
    import Imports from "./admin/Imports.svelte";

    import Navigation from "./layout/Navigation.svelte";
    import Categories from "./layout/Categories.svelte";

    import Dashboard from "./pages/Dashboard.svelte";
    import User from "./pages/User.svelte";

    import Brands from "./pages/Brands.svelte";
    import Products from "./pages/Products.svelte";
    import Product from "./pages/Product.svelte";

    import Sale from "./pages/Sale.svelte";
    import New from "./pages/New.svelte";

    import Orders from "./pages/Orders.svelte";
    import Order from "./pages/Order.svelte";
    import Invoices from "./pages/Invoices.svelte";
    import Invoice from "./pages/Invoice.svelte";

    import Carts from "./pages/Carts.svelte";
    import CartsSpecific from "./pages/CartsSpecific.svelte";
    import Cart from "./pages/Cart.svelte";

    import Finance from "./pages/Finance.svelte";

    import { fetchGet, fetchPost } from "./utils/utilsFetch.js";

    import {
        isMobile,
        isAuthenticated,
        isAdmin,
        isSales,
        salesCompanyKey,
        activePage,
        client,
        cartCount,
        isLoading,
        showSidebar,
        showReservationModal,
    } from "./stores.js";

    import { getDecodedToken, getCartCount } from "./utils/utils.js";

    let authRoute, authPage, page, props, adminPage, adminProps;

    let showUnderMaintenanceModal = false;

    // onMount(() => {
    //     showUnderMaintenanceModal = true;
    // });

    function isValidToken() {
        let isValid = false;
        let token = getDecodedToken();

        if (token && Date.now() <= token.exp * 1000) {
            isValid = true;
            $isAdmin = token.isAdmin;
            $isSales = token.isSales;
        } else {
            localStorage.removeItem("token");
        }

        return isValid;
    }

    async function authenticationMiddleware(ctx, next) {
        if (isValidToken()) {
            $isAuthenticated = true;

            next();
        } else {
            switch (ctx.pathname) {
                case "/login":
                    authPage = Login;
                    break;

                default:
                    authPage = Login;
            }
        }
    }

    router("*", authenticationMiddleware);

    function appendQueryParameter(ctx, next) {
        //  ctx.page.prevContext.path

        if ($salesCompanyKey && !ctx.path.includes("salesCompanyKey")) {
            const url = new URL(window.location.origin + ctx.path);
            url.searchParams.set("salesCompanyKey", $salesCompanyKey);

            router(url.href);
        }

        // const currentUrl = window.location.pathname + window.location.search;
        // const requiredParamValue = $salesCompanyKey; // Ensure this variable is accessible

        // // Only redirect if the parameter is missing or different
        // if (url.searchParams.get("salesCompanyKey") !== requiredParamValue) {
        //     window.history.replaceState(null, "", url.pathname + url.search);
        // }

        next();
    }

    // Intercept all routes for query parameter appending
    router("*", appendQueryParameter);

    async function utilsMiddleware(ctx, next) {
        $isLoading = true;

        // Create a URL object from the current location
        const currentUrl = new URL(window.location.href);

        // Use URLSearchParams to work with the query string
        const searchParams = new URLSearchParams(currentUrl.search);

        $salesCompanyKey = searchParams.get("salesCompanyKey");

        $isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        if ($isMobile) {
            $showSidebar = false;
        }

        $client = await fetchGet(`/api/client`);

        await getCartCount();

        $isLoading = false;

        next();
    }

    // Other middleware like utilsMiddleware comes after ensuring the necessary query params are appended
    router("*", utilsMiddleware);

    // PRODUCTS SEARCHBY ========================================================

    // ADMIN ========================================================

    router("/admin/users", async (ctx) => {
        if (!$isAdmin) return;
        $activePage = "users";
        adminPage = Users;
    });

    router("/admin/catalogue", async (ctx) => {
        if (!$isAdmin) return;
        $activePage = "catalogue";
        adminPage = Catalogue;
    });

    router("/admin/imports", async (ctx) => {
        if (!$isAdmin) return;
        $activePage = "imports";
        adminPage = Imports;
    });

    // GENERAL ========================================================

    router("/", async (ctx) => {
        if ($isAdmin) {
            $activePage = "admin";
            adminPage = Admin;
        } else {
            $activePage = "dashboard";
            page = Dashboard;
        }
    });

    router("/user", async (ctx) => {
        $activePage = "user";
        page = User;
    });

    router("/brands", async (ctx) => {
        $activePage = "brands";
        page = Brands;
    });

    router("/products", async (ctx) => {
        $activePage = "products";
        props = {
            querystring: ctx.querystring,
        };
        page = Products;
    });

    router("/Akcija", async (ctx) => {
        $activePage = "Akcija";
        page = Sale;
    });

    router("/Novo", async (ctx) => {
        $activePage = "Novo";
        page = New;
    });

    router("/products/:sku", async (ctx) => {
        $activePage = "product";
        props = {
            sku: ctx.params.sku,
        };
        page = Product;
    });

    router("/orders", async (ctx) => {
        $activePage = "orders";
        page = Orders;
    });

    router("/orders/:orderKey", async (ctx) => {
        $activePage = "orders";
        props = {
            orderKey: ctx.params.orderKey,
        };
        page = Order;
    });

    router("/invoices", async (ctx) => {
        $activePage = "invoices";
        page = Invoices;
    });

    router("/invoices/:invoiceKey", async (ctx) => {
        $activePage = "invoices";
        props = {
            invoiceKey: ctx.params.invoiceKey,
        };
        page = Invoice;
    });

    router("/carts", async (ctx) => {
        $activePage = "carts";
        page = Carts;
    });

    router("/carts/:cartId", async (ctx) => {
        $activePage = "cart";
        props = {
            cartId: ctx.params.cartId,
        };
        page = CartsSpecific;
    });

    router("/cart", async (ctx) => {
        $activePage = "cart";
        page = Cart;
    });

    router("/finance", async (ctx) => {
        $activePage = "finance";
        page = Finance;
    });

    router();
</script>

<svelte:head>
    <title>B2B Globo{$activePage ? ` - ${$activePage}` : ""}</title>

    <link
        href="https://unpkg.com/tabulator-tables/dist/css/tabulator.min.css"
        rel="stylesheet"
    />

    <link
        rel="stylesheet"
        href="https://use.fontawesome.com/releases/v5.8.2/css/all.css"
        integrity="sha384-oS3vJWv+0UjzBfQzYUhtDYW+Pj2yciDJxpsK1OYPAYjqT085Qq/1cq5FLXAZQ7Ay"
        crossorigin="anonymous"
    />
</svelte:head>

<!-- Prevents flashing the login screen -->
{#if $isAuthenticated}
    <div class="container">
        <Message />
        <Loader />
        <Navigation />
        <Modal bind:showModal={$showReservationModal}>
            <div slot="title">Rezervacija</div>
            <div slot="body">
                <div
                    class="wrapper"
                    style="display: flex; flex-direction: column; justify-content: center;"
                >
                    Rezervacija za termin dolaska artikla na lageru je uradjena.

                    <br />
                    <br />

                    <button
                        class="btn btn-blue"
                        on:click={() => {
                            $showReservationModal = false;
                        }}
                    >
                        OK
                    </button>
                </div>
            </div>
        </Modal>

        <Modal bind:showModal={showUnderMaintenanceModal}>
            <div slot="title">PAZNJA!</div>
            <div slot="body">
                <div
                    class="wrapper"
                    style="display: flex; flex-direction: column; justify-content: center;"
                >
                    PAZNJA!
                    <br /><br />
                    U toku su radovi na serveru u Austriji, moguce da trenutni lager
                    nije ispravan.
                    <br /><br />
                    Radi se na rjesavanju problema. Molim za strpljenje.
                    <br /><br />
                    Hvala na razumijevaju.

                    <br /><br />

                    <button
                        class="btn btn-blue"
                        on:click={() => {
                            showUnderMaintenanceModal = false;
                        }}
                    >
                        OK
                    </button>
                </div>
            </div>
        </Modal>

        {#if $isAdmin}
            <div class="content-full">
                <svelte:component this={adminPage} {...adminProps} />
            </div>
        {:else}
            <Categories />

            <div
                class:content={$showSidebar}
                class:content-full={!$showSidebar}
            >
                <svelte:component this={page} {...props} />
            </div>
        {/if}
    </div>
{:else}
    <svelte:component this={authPage} {...props} />
{/if}

<style>
    .container {
        height: 100%;
        display: grid;
        grid-template-columns: 200px 1fr;
        grid-template-rows: 50px calc(100vh - 50px);
    }

    .content {
        grid-row: 2/-1;
        grid-column: 2/3;
        overflow: auto;
    }

    .content-full {
        grid-column: 1/-1;
        grid-row: 2/-1;
        overflow: auto;
    }

    @media only screen and (max-device-width: 600px) {
        .container {
            grid-template-rows: 80px calc(100vh - 80px);
        }
    }
</style>
